/** @typedef {Object} ALKLogin
 * @property {String} login
 * @property {String} logout
 * @property {String} validate
 * @property {String} forgotPassword
 */

(function () {
  "use strict";

  angular
    .module("alk.authentication")
    .factory("ALKLogin", ALKLogin);

  /** @name ALKLogin
   * @ngdoc factory
   * @description A factory for an object that encapsulates login requests. 
   * @param {String} username - username for the request
   * @param {String} password - password for the request
   * @param {String} account - optional account name for the request.
   * @param {String} application - optional application name for the request.
   * @example
   * var login = new ALKLogin(username, password, acct);
   * @returns ALKLogin
   * @memberof alk.authentication
   */
  function ALKLogin() {
    return function (username, password, account = "", application = "") {
      this.username = username;
      this.password = password;
      this.account = account;
      this.application = application;

      this.isBaseValid = _.bind(() => this.username && this.username.length > 0 && this.password && this.password.length > 0, this);
      this.isAccountValid = _.bind(() => this.account.length > 0, this);
      this.isApplicationValid = _.bind(() => this.application.length > 0, this);
    };
  }
})();



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-authentication/factories/login.factory.js